import { useRouter } from "expo-router";
import React from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";

import { Block, Button, Typography, spacing } from "@stepapp/ui";

type Props = {
  description: string;
};

const UnregisteredPlaceholder = ({ description }: Props) => {
  const { navigate } = useRouter();
  const { t } = useTranslation();

  return (
    <Block style={styles.content}>
      <Typography type="secondary" variant="paragraph">
        {description}
      </Typography>

      <Block marginVertical={2}>
        <Button
          label={t("screens.auth.logIn")}
          onPress={() => navigate("/login/phone")}
          type="primary"
        />
      </Block>

      <Button label={t("screens.auth.order")} onPress={() => navigate("/")} type="secondary" />
    </Block>
  );
};

export default React.memo(UnregisteredPlaceholder);

const styles = StyleSheet.create({
  content: {
    marginTop: spacing.unit * 4,
  },
});
